import React, { useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "components/Layout/style.css";
import fr from "date-fns/locale/fr"; // the locale you want
import { Box } from "@mui/material";
import CalenderIcon from "assets/img/calendericon.svg";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import moment from "moment";

registerLocale("fr", fr);
const DatePickerYear = ({ filterAccToDate }) => {
  const [startDate, setStartDate] = useState(new Date());
  return (
    <>
      <Box style={{ display: "flex", placeItems: "center" }}>
        <img src={CalenderIcon} style={{ marginRight: "5px", width: "15px" }} />
        <div className="customyeardropdown">
          <DatePicker
            locale="fr"
            selected={startDate}
            onChange={(date) => {
              filterAccToDate(moment(date).format("L"));
              setStartDate(date);
            }}
            dateFormat="yyyy / MMMM"
            showMonthYearPicker
            showFullMonthYearPicker
            showTwoColumnMonthYearPicker
          />
        </div>
        <ArrowDropDownIcon />
      </Box>
    </>
  );
};

export default DatePickerYear;
